<template>
  <nav
    class="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"
  >
    <div
      class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
      >
        <img :src="logoUrl" width="200" />
        <!-- <router-link
          class="text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
          to="/"
        >
          Quintessence
        </router-link>         -->
        <button
          class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          v-on:click="setNavbarOpen"
        >
          <i class="text-white fas fa-bars"></i>
        </button>
      </div>
      <div
        class="lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none"
        :class="[navbarOpen ? 'block rounded shadow-lg' : 'hidden']"
        id="example-navbar-warning"
      >
       
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <!-- <li class="flex items-center">
            <PagesDropdown />
          </li> -->
          <li v-if="urls.instagram" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              :href="urls.instagram"
              target="_blank"
            >
              <i
                class="lg:text-blueGray-200 text-blueGray-400 fab fa-instagram text-lg leading-lg"
              />
              <span class="lg:hidden inline-block ml-2">Share</span>
            </a>
          </li>

          <li v-if="urls.twitter" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              :href="urls.twitter"
              target="_blank"
            >
              <i
                class="lg:text-blueGray-200 text-blueGray-400 fab fa-twitter text-lg leading-lg"
              />
              <span class="lg:hidden inline-block ml-2">Tweet</span>
            </a>
          </li>

          <li v-if="urls.tiktok" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              :href="urls.tiktok"
              target="_blank"
            >
              <i
                class="lg:text-blueGray-200 text-blueGray-400 fab fa-tiktok text-lg leading-lg"
              />
              <span class="lg:hidden inline-block ml-2">Tiktok</span>
            </a>
          </li>

          <li v-if="urls.snapchat" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              :href="urls.snapchat"
              target="_blank"
            >
              <i
                class="lg:text-blueGray-200 text-blueGray-400 fab fa-snapchat text-lg leading-lg"
              />
              <span class="lg:hidden inline-block ml-2">Snap</span>
            </a>
          </li>
          &nbsp;
          <li v-if="!user" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              @click.prevent="loginOrSignup()" href="#"
            >
              <i
                class="lg:text-blueGray-200 text-blueGray-400 far fa-user text-lg leading-lg mr-2"
              />
              Login or Signup
            </a>
          </li>
          <li v-if="user" class="items-center flex">
            <router-link to="/account">
              <a href="#">
                <span
                  class="w-8 h-8 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
                >
                  <img
                    alt="..."
                    class="w-full rounded-full align-middle border-none shadow-lg"
                    :src="profileImgSrc"
                  />
                </span>
              </a>
            </router-link>
          </li>  
          <li v-if="user" class="flex items-center">
            <router-link to="/account">
              <a
                class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                href="#"
              >
                My Account
              </a>
          </router-link>          
          <span style="color: white">|</span>
          </li>     
          <li class="flex items-center">
            <router-link to="/">
              <a
                class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                href="/"
              >
                <!-- <i
                  class="lg:text-blueGray-200 text-blueGray-400 far fa-user text-lg leading-lg mr-2"
                /> -->
                Home
              </a>
            </router-link>
            <span style="color: white">|</span>
          </li>  
          <li v-if="user" class="flex items-center">
            <a
              class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
              @click.prevent="logout()" href="#"
            >
              <!-- <i
                class="lg:text-blueGray-200 text-blueGray-400 far fa-user text-lg leading-lg mr-2"
              /> -->
              Logout
            </a>
          </li>
          <li class="flex items-center">
            <button
              @click="connect(true)"
              class="bg-white text-blueGray-700 active:bg-blueGray-50 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
              type="button"
            >
              <!-- <i class="fas fa-arrow-alt-circle-down"></i>  --> {{ellipsizedAccount ||  "Connect"}}
            </button>
          </li>
          <li class="flex items-center">
            <span class="lg:text-white lg:hover:text-blueGray-200 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold">
              {{ usdcBalanceDisplay }}
            </span>
          </li>
        </ul>
        
      </div>
    </div>
    
  </nav>
</template>
<script>
import { store } from '../../store'
import { PublicApi, AuthenticatedApi } from "@/services/Api.js";
import { StytchUIClient } from '@stytch/vanilla-js';
import { Environment } from '@/services/Environment.js';
import UserService from '../../services/UserService';
import WalletService from '../../services/WalletService';

export default {
  data() {
    return {
      user: null,
      navbarOpen: false,
      store,
      showModal: false,
      usdcBalance: "0",
      urls: {
        instagram: null,
        tiktok: null,
        snapchat: null,
        twitter: null,
      },
      profileImgSrc: "data:image/png;base64,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",
    };
  },
  props: {
    logoUrl: {
      type: String,
      default: "",
    }
  },  
  computed: {      
      ellipsizedAccount() {
        if (!this.store.account) {
          return "";
        }
        let prefix = this.store.account.slice(0, 6);
        let suffix = this.store.account.slice(-5);
        return `${prefix}...${suffix}`;
      },
      usdcBalanceDisplay() {
        if (!store.usdcBalance) {
          return "0.00 USDC";
        }
        return `${store.usdcBalance.toFixed(2)} USDC`
      }
  },
  methods: {
    setNavbarOpen: function () {
      this.navbarOpen = !this.navbarOpen;
    },
    async connect(userInitiated) {

      //Connect/disconnect toggle
      if (this.store.account && userInitiated) {
        this.store.account = null;
        //TODO: can you tell the wallet to disconnect? 
        this.store.usdcBalance = "";       
        return;
      }

      const walletService = new WalletService();
      this.store.account = await walletService.loadAccount();
      if (userInitiated) {
        this.store.account = await walletService.connectAccount();
        if (this.store.account) {
          const userService = new UserService();
          if (await userService.isLoggedIn()) {
            //If this wallet isn't associated with the user yet, do it now
            const api = new AuthenticatedApi(this.$cookies);
            await api.put('/api/user/wallets', {publicKey: this.store.account});
          }
        }        
      }  
      //Get USDC balance
      if (this.store.account) {
        this.store.usdcBalance = await walletService.getUsdcBalance(this.store.account);      
      }      
    },
    loginOrSignup() {
      let environment = new Environment();
      let loginUrl = environment.loginUrl
      //TODO: whitelist the state to return with... e.g. don't want jwt= if it's still there. other things?
      window.location.href  =`${loginUrl}?returnTo=${window.location.origin}`;
    },
    async loginWithJwt() {
      const params = new URLSearchParams(window.location.search);
      const jwt = params.get("jwt");
      const sessionToken = params.get("sessionToken");
      if (jwt) {
        console.log("Storing jwt in stytch_session_jwt cookie");
        this.$cookies.set("stytch_session_jwt", jwt);
        this.$cookies.set("stytch_session", sessionToken);

        //create the user if not already created
        let environment = new Environment();
        let stytchToken = environment.stytchToken;
        const stytch = new StytchUIClient(stytchToken);
        console.log(JSON.stringify(stytch.user, null, 2));

        console.log("Getting user...");
        const user = await stytch.user.get();
        if (user) {
          console.log("Upsert user");
          user.metadata = { apps: ["brand-site"], roles: ["end-user"], sites: [window.location.origin] }; //brands use the dashboard, end-users use the generated site.
          let api = new AuthenticatedApi(this.$cookies);
          let res = await api.post("/api/users", user);
          console.log(res.data);
          console.log("User exists or created successfully.");
        }
      }
    },
    async logout() {
      console.log("logout");
      let environment = new Environment();
      const stytchToken = environment.stytchToken;
      const stytch = new StytchUIClient(stytchToken);
      await stytch.session.revoke();
      this.$cookies.remove("stytch_session_jwt");
      this.$cookies.remove("stytch_session");
      window.location.reload();
    },
    async loadUserProfile() {

      const sessionJwt = this.$cookies.get("stytch_session_jwt");
      if (!sessionJwt) {
        return;
      }

      let environment = new Environment();
      let stytchToken = environment.stytchToken;
      const stytch = new StytchUIClient(stytchToken);

      const user = await stytch.user.get();
      if (user) {
        //console.log(JSON.stringify(user, null, 2));
        this.user = user;
        if (user.emails && user.emails.length > 0) {
          this.email = user.emails[0].email;
        }
        if (user.providers && user.providers.length > 0) {
          this.profileImgSrc = user.providers[0].profile_picture_url;
        }
          const api = new AuthenticatedApi(this.$cookies);
          let res = await api.get("/api/users/me");
          this.store.userMetadata = res.data;
          console.log(this.store.userMetadata);
      } else {
        console.log("No stytch user");
      }
    }
  },
  components: {
    //PagesDropdown,
  },
  async mounted() {

    await this.loginWithJwt(); 
    await this.loadUserProfile();
    await this.connect(false);
    
    const api = new PublicApi();  
    const res = await api.get("/api/public/settings");
    const settings = res.data;
    //Set handles
    if (settings.handles) {
      let instagram = settings.handles.instagram;
      if (instagram) {
        instagram = instagram.replace("@", "");
        this.urls.instagram = `https://www.instagram.com/${instagram}/`
      }
      let twitter = settings.handles.twitter;
      if (twitter) {
        twitter = twitter.replace("@", "");
        this.urls.twitter = `https://www.twitter.com/${twitter}/`
      }
      let tiktok = settings.handles.tiktok;
      if (tiktok) {
        this.urls.tiktok = `https://www.tiktok.com/${tiktok}/`
      }
      let snapchat = settings.handles.snapchat;
      if (snapchat) {
        snapchat = snapchat.replace("@", "");
        this.urls.snapchat = `https://www.snapchat.com/add/${snapchat}/`
      }
      //https://www.snapchat.com/add/mrcippy
    }
    this.store.settings = settings;
    console.log(JSON.stringify(this.urls));
  }
};
</script>
